/**
 * Path mechanics flat region for Engine Editor — substrate × calculation
 * cell (flat-regions mode, 2 of 3 vertically stacked) per scope-doc §2
 * cell-by-cell routing.
 *
 * Sub-shape 4b-deferred (admin / specialized-surface, V2-promotion-named).
 * `fulfillment_path_config` lives primarily at Settings → Channels & Paths
 * Engine Tuning subsection (Day 86 P7.2 A6 split) through V1. V2 promotion
 * criterion: build-window per scope-doc §4.2 line 570.
 */

import type { JSX } from 'react';
import { Truck } from 'lucide-react';
import { URL_SETTINGS_CHANNELS_AND_PATHS } from '../../../lib/engine-editor/engineEditorUrls';

export default function EngineEditorPathMechanics(): JSX.Element {
  return (
    <section
      id="path-mechanics"
      data-cell-coordinate="substrate-calculation"
      data-region-type="region"
      className="border border-border bg-surface-1 rounded-lg p-4 space-y-3"
    >
      <div className="flex items-start gap-2">
        <Truck size={16} className="text-ink-secondary flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h2 className="text-sm font-semibold text-ink-bright">Path mechanics</h2>
          <p className="text-xs text-ink-secondary mt-1">
            Per-path mechanics (prep fees, inbound shipping, fee structure) shaping
            engine path calculations.
          </p>
        </div>
      </div>

      {/* COMPOSABILITY: per-section "Last changed X days ago" indicator slot — wires post-Day 92 */}

      <p className="text-xs text-ink-muted italic pt-2 border-t border-border-subtle">
        Edit at{' '}
        <a
          href={URL_SETTINGS_CHANNELS_AND_PATHS}
          className="text-accent hover:underline not-italic"
        >
          Settings → Channels &amp; Paths (Engine Tuning subsection)
        </a>
        . Engine Editor absorbs at V2 (build-window).
      </p>
    </section>
  );
}
